import { Textarea } from '@chakra-ui/react'
import { clsx } from 'clsx'
import { forwardRef } from 'react'

import type { TextareaHTMLAttributes } from 'react'

type TextAreaProperties = TextareaHTMLAttributes<HTMLTextAreaElement>

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProperties>(
  ({ className, rows, ...properties }, reference) => {
    /* --- Section 6: Render --- */
    return (
      <Textarea
        {...properties}
        autoresize
        bg="var(--theme-card-background)"
        borderRadius="[var(--radius-sm)]"
        className={clsx('ui-text-area', className)}
        color="var(--theme-text-color)"
        fontSize="[14px]"
        minH="[44px]"
        px="[14px]"
        py="[10px]"
        ref={reference}
        resize="none"
        rows={rows}
        _disabled={{
          cursor: '[not-allowed]',
          opacity: '[0.6]',
        }}
        _placeholder={{
          color: 'var(--theme-text-color-muted)',
        }}
      />
    )
  }
)

TextArea.displayName = 'TextArea'
